<template>
  <configurable-table
    :report="report"
  >
    <template #total>
      <a-dashboard
        :api="capital.getAlreadySettleInfo"
        :options="[
          {
            title: '已结算货款总额',
            key: 'settleGoodAmount',
          },
          {
            title: '已结算佣金总额',
            key: 'settleCommissionAmount'
          },
        ]"
      />
      <!-- {
            title: '已结算奖励金总额',
            key: 'settleDevelopAmount'
          } -->
    </template>
  </configurable-table>
</template>

<script>
import { capital } from '@/api'
import ConfigurableTable from './ConfigurableTable'
import { Report } from './report'
import ADashboard from './ADashBoard'
import moment from 'moment'
import { createMapFromList } from '@/utils/tools'
import { settleTransactionTypes, settleTypes } from '@/utils/constants'

export default {
  name: 'PageSettleAlready',
  components: {
    ConfigurableTable,
    ADashboard,
  },
  setup () {
    const queryFields = [
      {
        type: 'select',
        key: 'supplyShopId',
        title: '供货商',
        options: async () => {
          const { data } = await capital.getSupplyShopOfMine()
          return data.map(x => ({
            name: x.name,
            value: x.shopId
          }))
        },
      },
      {
        type: 'input',
        key: 'orderNo',
        title: '订单号',
      },
      {
        type: 'select',
        key: 'type',
        title: '结算类型',
        options: settleTypes
      },
      {
        type: 'select',
        key: 'transactionType',
        title: '交易类型',
        options: settleTransactionTypes
      },
      {
        type: 'daterange',
        key: 'settleRange',
        title: '结算日期',
      },
      {
        type: 'daterange',
        key: 'range',
        title: '交易日期',
      },
    ]

    const resultFields = [
      {
        key: 'transactionTime',
        title: '交易日期',
        transform: x => moment(x).format('YYYY-MM-DD')
      },
      {
        key: 'shopName',
        title: '供货商',
      },
      {
        key: 'type',
        title: '结算类型',
        transform: x => createMapFromList(settleTypes)[x]
      },
      {
        key: 'transactionType',
        title: '交易类型',
        transform: x => createMapFromList(settleTransactionTypes)[x]
      },
      {
        key: 'productName',
        title: '商品名称'
      },
      {
        key: 'orderNo',
        title: '订单编号'
      },
      {
        key: 'settleAmount',
        title: '订单金额'
      },
      {
        key: 'tradePrice',
        title: '供货价'
      },
      {
        key: 'serviceFee',
        title: '平台服务费'
      },
      {
        key: 'realAmount',
        title: '已结算金额'
      }
    ]

    return {
      capital,
      report: new Report(queryFields, resultFields, {
        key: 'orderIncomeId',
        queryApi: ({ range, settleRange, ...others }) => {
          return capital.getAlreadySettlePage({
            ...others,
            ...(range.length ? {
              transactionBeginTime: range[0].format('YYYY-MM-DD 00:00:00'),
              transactionEndTime: range[1].format('YYYY-MM-DD 23:59:59')
            } : null),
            ...(settleRange.length ? {
              settleBeginTime: settleRange[0].format('YYYY-MM-DD 00:00:00'),
              settleEndTime: settleRange[1].format('YYYY-MM-DD 23:59:59')
            } : null),
          })
        },
        exportApi: ({ range, settleRange, ...others }) => {
          return capital.exportAlreadySettle({
            ...others,
            ...(range.length ? {
              transactionBeginTime: range[0].format('YYYY-MM-DD 00:00:00'),
              transactionEndTime: range[1].format('YYYY-MM-DD 23:59:59')
            } : null),
            ...(settleRange.length ? {
              settleBeginTime: settleRange[0].format('YYYY-MM-DD 00:00:00'),
              settleEndTime: settleRange[1].format('YYYY-MM-DD 23:59:59')
            } : null),
          })
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>

</style>
